import { apiConnector } from "../apiConnection";
import { addFeedbackEndpoint } from "../apiEndpoints";
//TODO
// export const addFeedbackApi = async (platform, feedback) => {
//   const bodyData = {
//     platform,
//     feedback,
//   };
//   try {
//     const request = {
//       method: addFeedbackEndpoint.method,
//       url: addFeedbackEndpoint.url,
//       bodyData,
//       withCredentials: true,
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     };

//     const response = await apiConnector(request);
//     if (!response || !response.data.success) {
//       throw new Error(
//         response.data.message || "Error occurred while submitting feedback"
//       );
//     }

//     return response.data;
//   } catch (error) {
//     console.error("Error in addFeedbackApi:", error);
//     throw error; // Re-throw the error for further handling
//   }
// };

export const addFeedbackApi = async (platform, feedback) => {
  toast.success("your feedback has been submitted successfully!");
};
